import { render, staticRenderFns } from "./DuplicateDependents.vue?vue&type=template&id=96beebd4&"
import script from "./DuplicateDependents.vue?vue&type=script&lang=js&"
export * from "./DuplicateDependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports